import { OverlayContainer } from '@angular/cdk/overlay';
import { createComponent, EnvironmentInjector, inject, Injectable } from '@angular/core';

import { ShadowOverlayContainerRootComponent } from '../components/shadow-overlay-container-root/shadow-overlay-container-root.component';

@Injectable()
export class ShadowOverlayContainer extends OverlayContainer {
  public injector: EnvironmentInjector = inject(EnvironmentInjector);
  protected _createContainer() {
    const cp = createComponent(ShadowOverlayContainerRootComponent, {
      environmentInjector: this.injector,
    });

    cp.changeDetectorRef.detectChanges();
    this._containerElement = cp.instance.root.nativeElement;
    document.body.appendChild(cp.location.nativeElement);
  }
}
